import { createContext, useCallback, useState } from 'react';
import { CountryOption } from '../mytm/country/country';

const DEFAULT_COUNTRY = [
  {
    code: 'USA',
    name: 'United States',
    status: 'ACTIVE',
  },
  {
    code: 'CAN',
    name: 'Canada',
    status: 'ACTIVE',
  },
  {
    code: 'GBR',
    name: 'United Kingdom',
    status: 'ACTIVE',
  },
  {
    code: 'DEU',
    name: 'Germany',
    status: 'ACTIVE',
  },
  {
    code: 'FRA',
    name: 'France',
    status: 'ACTIVE',
  },
  {
    code: 'SWE',
    name: 'Sweden',
    status: 'ACTIVE',
  },
  {
    code: 'AUS',
    name: 'Australia',
    status: 'ACTIVE',
  },
];

interface DefaultContextCountry {
  countryListFull: CountryOption[];
  updateCountryListFull: (data: CountryOption[]) => void;
}

const DEFAULT_CONTEXT: DefaultContextCountry = {
  countryListFull: DEFAULT_COUNTRY,
  updateCountryListFull: (data: any) => {},
};

export const CountryFullContext = createContext(DEFAULT_CONTEXT);

export function useCountryFullContext(): DefaultContextCountry {
  const [countryListFull, setCountryListFull] = useState(DEFAULT_COUNTRY);
  const updateCountryListFull = useCallback((data): void => {
    setCountryListFull(data);
  }, []);

  return {
    countryListFull,
    updateCountryListFull,
  };
}
